import './checkbox.scss';

type Props = {
  className?: string;
  id?: string;
  value?: boolean;
  name?: string;
  label?: string;
  onChange?: (e?: any) => void;
};

const Checkbox: React.FC<Props> = (props: Props) => {
  const { name = '', id = '', value = false, label = '', className = '', onChange = () => { } } = props;
  return (
    <div className={`ui-checkbox ${className}`} data-testid="checkbox">
      <input
        type="checkbox"
        id={id}
        name={name}
        value={value ? 1 : 0}
        checked={!!value}
        onChange={onChange}
      />
      <label htmlFor={id}>{label}</label>
    </div>
  );
};

export default Checkbox;
